import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorView } from "./ErrorView";
import { FetchErrorView } from "./FetchErrorView";
/**
 * Display various errors
 * - [Error object](https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Error)
 * - [Fetch Error](https://developer.mozilla.org/de/docs/Web/API/Response)
 *
 * @param props
 * @returns
 */
export function CommonErrorView(props) {
    if ("message" in props.error) {
        return _jsx(ErrorView, { error: props.error });
    }
    // we cannot access the body here
    if ("body" in props.error) {
        return _jsx(FetchErrorView, { response: props.error });
    }
    return _jsx(ErrorView, { error: new Error("Unknown error occurred") });
}
//# sourceMappingURL=CommonErrorView.js.map